import { UserAbility } from "modules/user/config/permissions/Can";

export const ability: Partial<UserAbility> = {
  people_stats: {
    read: ["master", "executive", "program_manager"],
    config: ["master", "executive", "program_manager"],
    create: ["master", "executive", "program_manager"],
    update: ["master", "executive", "program_manager"],
    delete: ["master", "executive", "program_manager"]
  },
  user_details: {
    read: ["master", "executive", "program_manager"],
    config: ["master", "executive", "program_manager"],
    create: ["master", "executive", "program_manager"],
    update: ["master", "executive", "program_manager"],
    delete: ["master", "executive", "program_manager"]
  },
  playbooks: {
    read: ["all"],
    config: ["master", "executive", "program_manager"],
    create: ["master", "executive", "program_manager"],
    update: ["master", "executive", "program_manager"],
    delete: ["master", "executive", "program_manager"]
  }
};
